import React from 'react';
import { Camera } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-white py-12 border-t border-white/10" data-id="element-47">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-48">
        <div className="flex items-center gap-1" data-id="element-49">
          <span className="font-serif text-xl tracking-wide text-white" data-id="element-50">
            photos by <span className="italic" data-id="element-51">tunga</span>
          </span>
        </div>

        <div className="flex gap-8 text-sm text-white/60" data-id="element-52">
          <a href="#home" className="hover:text-gold transition-colors" data-id="element-53">
            Home
          </a>
          <a href="#portfolio" className="hover:text-gold transition-colors" data-id="element-54">
            Portfolio
          </a>
          <a href="#services" className="hover:text-gold transition-colors" data-id="element-55">
            Services
          </a>
          <a href="#contact" className="hover:text-gold transition-colors" data-id="element-56">
            Contact
          </a>
        </div>

        <div className="text-xs text-white/40 uppercase tracking-widest" data-id="element-57">
          © 2026 Photos by Tunga
        </div>
      </div>
    </footer>;
}